import { QuestionCircleFilled, InfoCircleOutlined } from "@ant-design/icons"
import { Popover } from "antd"
import { CommentButton } from "../../admin/submissions/review"

import PropTypes from "prop-types"

FieldLabel.propTypes = {
  helpText: PropTypes.object,
  children: PropTypes.any,
  comentable: PropTypes.object
   //objeto que me dice la entidad a la que pertenece el comentario, por ejemplo Activity y la sección por ejemplo objetivo especifico
}

export function FieldLabel({ helpText, children, comentable, isEvent = false }) {

  return (
    <Popover
      content={helpText}
      overlayStyle={!helpText && { display: "none" }}>
      {children}&nbsp;
      {helpText ? isEvent ? <InfoCircleOutlined/> : <QuestionCircleFilled /> : null}
      &nbsp;
      {comentable && !comentable?.hidden ? <CommentButton {...comentable} /> : null}
    </Popover>
  )
}
